import { render, staticRenderFns } from "./CreateOffice.vue?vue&type=template&id=2bda2f23"
import script from "./CreateOffice.vue?vue&type=script&lang=js"
export * from "./CreateOffice.vue?vue&type=script&lang=js"
import style0 from "./CreateOffice.vue?vue&type=style&index=0&id=2bda2f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports